import React from 'react';

import { SubscriptionStatus, SubscriptionSubstatus } from '$/GraphQL/schema/schema';

import { usePlanPageContext } from '../PlanPage';
import { SwitchingType } from '../SubscriptionInfo';
import { SwitchingPlanModal } from './SwitchingPlanModal';
import { useSwitchPlans } from './useSwitchPlans';
import Button from '$/components/ui/Button';

export const SwitchingPlanButton: React.FC = () => {
  const { subscriptionInfo } = usePlanPageContext();
  const [showModal, setShowModal] = React.useState(false);
  const { submitting, switchPlans } = useSwitchPlans();

  const onClick = React.useCallback(() => {
    if (
      subscriptionInfo.isInTrial ||
      subscriptionInfo.isSuspended ||
      subscriptionInfo.switchingType === SwitchingType.BackToAnnual
    ) {
      switchPlans();
    } else {
      setShowModal(true);
    }
  }, [
    subscriptionInfo.isInTrial,
    subscriptionInfo.isSuspended,
    subscriptionInfo.switchingType,
    switchPlans,
  ]);

  if (
    [SubscriptionStatus.PastDue].includes(subscriptionInfo.status) ||
    subscriptionInfo.subStatus === SubscriptionSubstatus.Pending ||
    subscriptionInfo.isLegacyTeam
  ) {
    return null;
  }

  return (
    <>
      <Button.submit submitting={submitting} onClick={onClick} className='w-full mt-1/2e'>
        {subscriptionInfo.switchingButtonText}
      </Button.submit>
      <SwitchingPlanModal showModal={showModal} onCancel={(): void => setShowModal(false)} />
    </>
  );
};
